import type { Ref } from 'vue';

export function useResetScroll(visible: Ref<boolean>, elRef: Ref<HTMLElement | null>) {
  watch(visible, (val) => {
    if (val) {
      nextTick(() => {
        elRef.value?.scrollTo({ top: 0 });
      });
    }
  });
}
